var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-dialog",
        {
          attrs: { fullscreen: "" },
          model: {
            value: _vm.isDialogOpen,
            callback: function($$v) {
              _vm.isDialogOpen = $$v
            },
            expression: "isDialogOpen"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: {
                        click: function($event) {
                          return _vm.close()
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                  _c(
                    "v-toolbar-title",
                    {
                      staticStyle: {
                        "font-size": "17px",
                        "margin-left": "10px !important"
                      }
                    },
                    [_vm._v("Certificado de Dispositivos\n        ")]
                  ),
                  _c("v-spacer")
                ],
                1
              ),
              _c("v-divider"),
              _c("v-card-text", { attrs: { center: "" } }, [
                _c("object", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.pdfObject,
                      expression: "pdfObject"
                    }
                  ],
                  staticStyle: { width: "inherit", height: "720px" },
                  attrs: { data: _vm.pdfObject, type: "application/pdf" }
                })
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }